import AbstractException from '../AbstractException.js';
import ExceptionTypeEnum from '../enums/ExceptionTypeEnum.js';
/**
 * Custom exception.
 */
export default class ServerErrorResponseException extends AbstractException {
    /**
     * Class constructor.
     *
     * @param response Server response.
     * @param message Message.
     */
    constructor(response, message) {
        super(`Failed to fetch from "${response.url}". Server responded with ${response.status} ${response.statusText}.${message ? ` Error: ${message}` : ''}`);
        this.exceptionType = ExceptionTypeEnum.serverErrorResponse;
        this.name = 'ServerErrorResponseException';
        this.serverResponse = response;
    }
}
//# sourceMappingURL=ServerErrorResponseException.js.map